export default __webpack_public_path__ + "static/media/rehack-13.d639ae2d.png";